import React, { useEffect, useState } from 'react';
import db from './firebase';
import { useParams } from 'react-router-dom';

function Redirect() {
  const { slug } = useParams();
  const [urls, setUrls] = useState([]);
  const [redirecting, setRedirecting] = useState(true);

  useEffect(() => {
    let query = db.collection('urls').where('slug', '==', slug);
    query.onSnapshot((data) => {
      if (data.empty) {
        alert('URL not found');
      }
      let finalData = data.docs[0].data();
      setUrls([finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url, finalData.url].map(url => encodeURIComponent(url)));
    });
  }, [slug]);

  useEffect(() => {
    if (urls.length > 0) {
      let randomIndex = Math.floor(Math.random() * urls.length);
      let redirectUrl = `vnd.youtube://youtube.com/redirect?event=comments&redir_token=QUFFLUhqbXIzaUN5blNvYkVibWktUzhUNFNYblpmcVNhQXxBQ3Jtc0tsV25RVWRrcHNXbE5WTzllSjhJU3V1RU1ZWnJTd3M0THdNeUFIbDRqRzhyb0JsZ0JOemtySGxESGNlQnd5M2hRN21xMHBEWlpHTjFUYmhKaWRMcXFsbWh1VGhndU1uTFFlbksyUk52M0xLMDZzbXJ4VQ&q=${urls[randomIndex]}&html_redirect=1`;
      window.location.href = redirectUrl;
    }
  }, [urls]);

  return (
    <div className="container text-center">
      {redirecting && <p> </p>}
    </div>
  );
}

export default Redirect;
